import { useEffect, useState } from "react";
import { publishAuthEvent, subscribeAuthEvents, TAB_ID } from "@/lib/auth-channel";

const REPLY_WINDOW_MS = 500;

export function DuplicateTabBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let mounted = true;
    let withinReplyWindow = true;

    const unsub = subscribeAuthEvents((event) => {
      if (event.type === "tab-announce") {
        // Another (newer) tab is announcing itself — reply so it knows we're
        // already here. We only reply, we don't show the banner ourselves.
        publishAuthEvent({
          type: "tab-reply",
          tabId: TAB_ID,
          toTabId: event.tabId,
        });
      } else if (
        event.type === "tab-reply" &&
        event.toTabId === TAB_ID &&
        withinReplyWindow
      ) {
        // Someone answered our announcement within the window — we're the
        // newer duplicate tab, so show the warning.
        if (mounted) setShow(true);
      }
    });

    publishAuthEvent({ type: "tab-announce", tabId: TAB_ID });

    const windowTimer = window.setTimeout(() => {
      withinReplyWindow = false;
    }, REPLY_WINDOW_MS);

    return () => {
      mounted = false;
      window.clearTimeout(windowTimer);
      unsub();
    };
  }, []);

  if (!show) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="w-full bg-primary text-sidebar border-b border-primary-border"
      data-testid="duplicate-tab-banner"
    >
      <div className="max-w-5xl mx-auto px-4 py-2">
        <p className="text-sm font-medium text-center">
          You already have this app open in another tab. Using multiple tabs at
          once can cause issues syncing — we recommend closing the others.
        </p>
      </div>
    </div>
  );
}
